import React from "react";
import {
  Container,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography,
} from "@mui/material";

const Products = () => {
  const products = [
    {
      title: "Zinguería estándar y a medida",
      description: "Resistentes a la corrosión y con gran durabilidad.",
      img: "productos1.png",
    },
    {
      title: "Accesorios",
      description: "Todo tipo de caños y accesorios.",
      img: "productos2.png",
    },
    {
      title: "Campanas, Sombreros, Tirajes",
      description: "Campanas para parrillas, tirajes de extracción de humos.",
      img: "productos3.png",
    },
  ];

  return (
    <Container id="products" style={{ padding: "80px 0" }}>
      <Typography variant="h4" align="center" gutterBottom>
        Productos Destacados
      </Typography>
      <Grid container spacing={4}>
        {products.map((product, index) => (
          <Grid item key={index} xs={12} sm={6} md={4}>
            <Card
              style={{
                transition: "transform 0.3s",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.transform = "scale(1.05)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.transform = "scale(1)")
              }
            >
              <CardMedia
                component="img"
                alt={product.title}
                height="140"
                image={product.img}
              />
              <CardContent>
                <Typography variant="h5">{product.title}</Typography>
                <Typography variant="body2" color="textSecondary">
                  {product.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Products;
